import { useHubMethod } from '@Contexts/signal';
import { MessagingConstants } from '@Model';
import { type IApiMessage, useToasts } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useLogout } from './useMsal';

const LOGOUT_NOTIFICATION_DELAY_MS = 4000;

// @ai-generated 2026-06-22T00:00:00+00:00 by philipp.kammerer@synqony.com using opus-4.8
export function useRemoteLogout() {
    const logout = useLogout();
    const { pushToast, pushAllToasts } = useToasts();

    const onLogout = useCallback(
        (payload: string) => {
            const notifications: IApiMessage | IApiMessage[] = JSON.parse(payload);
            if (Array.isArray(notifications)) {
                pushAllToasts(notifications);
            } else {
                pushToast(notifications);
            }

            setTimeout(async () => {
                await logout();
            }, LOGOUT_NOTIFICATION_DELAY_MS);
        },
        [logout, pushToast, pushAllToasts],
    );

    useHubMethod(MessagingConstants.logout, onLogout);
}
